import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { pipelineService } from '@/features/pipeline/services/pipeline.service';
import { KanbanBoard } from '@/features/pipeline/components/KanbanBoard';
import { AiLeadDialog } from '@/features/pipeline/components/AiLeadDialog';
import { Plus } from 'lucide-react';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/pipeline/kanban')({
  component: KanbanPage,
});

function KanbanPage() {
  const { data: leads = [], isLoading } = useQuery({
    queryKey: ['pipeline-leads'],
    queryFn: pipelineService.listLeads,
  });

  return (
    <PermissionGate permission={Permission.PIPELINE_VIEW}>
      <div className="p-6 space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="font-display text-3xl font-semibold tracking-tight">Pipeline</h1>
            <p className="text-sm text-muted-foreground mt-1">Arraste os cards entre as etapas.</p>
          </div>
          <div className="flex items-center gap-2">
            <AiLeadDialog />
            <Link
              to="/pipeline/leads/novo"
              className="inline-flex items-center gap-1 rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
            >
              <Plus className="h-4 w-4" /> Novo lead
            </Link>
          </div>
        </div>
        {isLoading ? (
          <div className="text-muted-foreground text-sm">Carregando...</div>
        ) : (
          <KanbanBoard leads={leads} />
        )}
      </div>
    </PermissionGate>
  );
}
